import type { Entity, SKLEngineInterface } from '../util/Types';

export type SklHookContext = {
  entities: Entity[];
  operation: string;
  operationParameters: Record<string, any>;
  sklEngine?: SKLEngineInterface;
  bypassHooks?: boolean;
};
